import { Media } from 'ca-api-client';
import { downloadBlob } from 'ca-js-helper';

const media = new Media();

export const downloadGetters = {
    /**
     * getDownloadManyUrl - Generates url for downlaoding many media items
     * @param {string} base64Items - Base64 encoded array of media id's
     */
    getDownloadManyUrl: (state) => (base64Items) => {
        return `${media.endpoint()}/download-many/${base64Items}?token=${ca.user.token}`;
    },
};

// TODO: chack if below are being used.
export const downloadActions = {
    async mediaDownload({ commit }, item) {
        let promise = false;

        if (item.type !== 'before_after') {
            if (item.type === 'image') {
                promise = await item.downloadURL(item.url).then((response) => {
                    downloadBlob(response.data, item.file.mime_type, item.file.filename);
                });
            } else {
                promise = await item.download().then((response) => {
                    downloadBlob(response.data, item.file.mime_type, item.file.filename);
                });
            }
        } else {
            const metadata = item.metadata.before_after;
            const mediaIds = [metadata.before.media_id, metadata.after.media_id];

            promise = await media.downloadMany(mediaIds).then((response) => {
                const time = new Date().getTime();
                downloadBlob(response.data, 'application/zip', `before-after-${time}.zip`);
            });
        }

        return promise;
    },

    async mediaDownloadById({ commit }, id) {
        const item = await media.$find(id);
        return await item.download().then((response) => {
            downloadBlob(response.data, item.file.mime_type, item.file.filename);
        });
    },

    async mediaDownloadMany({ commit }, mediaIds) {
        return await media.downloadMany(mediaIds).then((response) => {
            const time = new Date().getTime();
            downloadBlob(response.data, 'application/zip', `media-${time}.zip`);
        });
    },

    async mediaDownloadCameraFile({ commit }, item) {
        return item.downloadMetadata().then((response) => {
            const time = new Date().getTime();
            downloadBlob(response.data, 'application/json', `${item.file.filename}-${time}.camera`);
        });
    },

    async mediaDownloadOriginal({ commit }, item) {
        return await item.download({ original: true }).then((response) => {
            downloadBlob(response.data, item.file.mime_type, item.file.filename);
        });
    },
};
